import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Badge, Spinner } from '@fortem-monorepo/react-ui';
const keys = ['inProgress', 'success', 'error'];
const defaultConfig = {
    inProgress: {
        values: ['pending', 'inProgress', 'waiting', 'running'],
        label: 'Running...',
        icon: _jsx(Spinner, { width: 16 }),
    },
    success: {
        values: ['success', 'completed', 'complete', 'done', 'finished'],
        label: 'Completed',
    },
    error: {
        values: ['error', 'errored', 'failed', 'fail', 'broken'],
        label: 'Failed',
    },
};
export const createStatusCellRenderer = (options = defaultConfig) => {
    const StatusCellRenderer = ({ value, data, }) => {
        const { success, inProgress, error, _default } = {
            ...defaultConfig,
            ...options,
        };
        const renderInProgress = !!inProgress?.renderIf
            ? inProgress.renderIf({ value, data })
            : inProgress?.values?.includes(value);
        const renderSuccess = !!success?.renderIf
            ? success.renderIf({ value, data })
            : success?.values?.includes(value);
        const renderError = !!error?.renderIf
            ? error.renderIf({ value, data })
            : error?.values?.includes(value);
        const renderDefault = !renderInProgress && !renderSuccess && !renderError;
        return (_jsxs("div", { className: 'flex items-center justify-center gap-2 w-full h-full', children: [renderInProgress && (_jsxs(Badge, { variant: 'secondary', theme: "warning", children: [inProgress?.icon, typeof inProgress?.label === 'function'
                            ? inProgress?.label({ value, data })
                            : inProgress?.label] })), renderSuccess && (_jsx(_Fragment, { children: _jsxs(Badge, { variant: 'outline', size: 'default', theme: "success", children: [success?.icon, typeof success?.label === 'function'
                                ? success?.label({ value, data })
                                : success?.label] }) })), renderError && (_jsx(_Fragment, { children: _jsxs(Badge, { variant: 'outline', size: 'default', theme: "destructive", children: [error?.icon, typeof error?.label === 'function' ? error?.label({ value, data }) : error?.label] }) })), renderDefault && _default?.({ data, value })] }));
    };
    return React.memo(StatusCellRenderer, (prev, next) => {
        return prev.value === next.value;
    });
};
